export default __webpack_public_path__ + "static/co-virtual-64a41fd94fe8c52a2101b78f4ce240f1.svg";